import React, { useRef, useState } from "react";

import useDismissOnOutsideClick from "./useDismissOnOutsideClick";

export default function MapIconColorLegend({ placement = "top" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useDismissOnOutsideClick(open, rootRef, () => setOpen(false));

  return (
    <div
      ref={rootRef}
      className={`dashboard-map-icon-legend-wrap dashboard-map-icon-legend-wrap--${placement}`}
    >
      <button
        type="button"
        className="dashboard-map-icon-legend-toggle"
        aria-expanded={open}
        aria-label="Legenda de cores dos ícones"
        title="Legenda de cores"
        onClick={() => setOpen((current) => !current)}
      >
        <span className="dashboard-map-icon-legend-toggle__swatches" aria-hidden>
          <i className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--green" />
          <i className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--yellow" />
          <i className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--orange" />
          <i className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--blue" />
        </span>
      </button>
      {open ? (
        <div className="dashboard-map-icon-legend" aria-label="Cores dos ícones">
          <div className="dashboard-map-icon-legend__row">
            <span className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--green" />
            <span>Verde — em movimento</span>
          </div>
          <div className="dashboard-map-icon-legend__row">
            <span className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--yellow" />
            <span>Amarelo — parada e assumida</span>
          </div>
          <div className="dashboard-map-icon-legend__row">
            <span className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--orange" />
            <span>Laranja — telemetria desligada</span>
          </div>
          <div className="dashboard-map-icon-legend__row">
            <span className="dashboard-map-icon-legend__dot dashboard-map-icon-legend__dot--blue" />
            <span>Azul — pausa de intervalo</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
